export const baseFields = [
  {
    value: 'chats',
    label: 'Чаты',
    marker: '#FF2DF8',
    subColor: 'rgba(255, 45, 248, 5%)',
    subItems: [
      {
        value: 'chats_count',
        label: 'Кол-во',
        color: '#FF2DF8',
        subColor: 'rgba(255, 45, 248, 5%)',
        fontWeight: 'bold',
        type: 'count',
        sort: true,
      },
      {
        value: 'chats_avg_time',
        label: 'AVG Время',
        type: 'time',
        sort: true,
      },
      {
        value: 'chats_median_time',
        label: 'Median Время',
        type: 'time',
        sort: true,
      },
      {value: 'chat2reg', label: 'Chat2Reg', type: 'conversion', sort: true},
      {
        value: 'chat2fd',
        label: 'Chat2Fd',
        type: 'conversion',
        sort: true,
      },
      {
        value: 'chat2qualified',
        label: 'Chat2Qualified',
        type: 'conversion',
        sort: true,
      },
    ],
  },
  {
    value: 'registration',
    label: 'Регистрации',
    marker: '#AF52DE',
    subColor: 'rgba(175, 82, 222, 5%)',
    type: 'link',
    subItems: [
      {
        value: 'registration_count',
        label: 'Кол-во',
        color: '#AF52DE',
        subColor: 'rgba(175, 82, 222, 5%)',
        fontWeight: 'bold',
        type: 'count',
        sort: true,
      },
      {
        value: 'registration_avg_time',
        label: 'AVG Время',
        type: 'time',
        sort: true,
      },
      {
        value: 'registration_median_time',
        label: 'Median Время',
        type: 'time',
        sort: true,
      },
      {
        value: 'reg2fd',
        label: 'Reg2Fd',
        type: 'conversion',
        clue: 'Конверсия регистраций в первый депозит',
        sort: true,
      },
      {
        value: 'reg2qualified',
        label: 'Reg2Qualified',
        type: 'conversion',
        clue: 'Конверсия регистраций в квалификации',
        sort: true,
      },
    ],
  },
  {
    value: 'first_deposit',
    label: 'Первые Депозиты',
    marker: '#00C7BE',
    subColor: 'rgba(0, 199, 190, 5%)',
    type: 'link',
    subItems: [
      {
        value: 'first_deposit_count',
        label: 'Кол-во',
        color: '#00C7BE',
        subColor: 'rgba(0, 199, 190, 5%)',
        fontWeight: 'bold',
        type: 'count',
        sort: true,
      },
      {
        value: 'first_deposit_amount',
        label: 'Сумма',
        fontWeight: 'bold',
        type: 'cash',
        sort: true,
      },
      {
        value: 'first_deposit_avg_amount',
        label: 'AVG Сумма',
        fontWeight: 'bold',
        type: 'cash',
        sort: true,
      },
      {
        value: 'first_deposit_median_amount',
        label: 'Median Сумма',
        fontWeight: 'bold',
        type: 'cash',
        sort: true,
      },
      {
        value: 'first_deposit_avg_time',
        label: 'AVG Время',
        type: 'time',
        sort: true,
      },
      {
        value: 'first_deposit_median_time',
        label: 'Median Время',
        type: 'time',
        sort: true,
      },
      {
        value: 'fd2qualified',
        label: 'Fd2Qualified',
        type: 'conversion',
        clue: 'Конверсия первых депозитов в квалификации',
        sort: true,
      },
    ],
  },
  {
    value: 'qualified',
    label: 'Квалификации',
    marker: '#9BC734',
    subColor: 'rgba(155, 190, 52, 5%)',
    type: 'link',
    subItems: [
      {
        value: 'qualified_count',
        label: 'Кол-во',
        color: '#9BC734',
        subColor: 'rgba(155, 190, 52, 5%)',
        fontWeight: 'bold',
        type: 'count',
        sort: true,
      },
      {
        value: 'qualified_avg_time',
        label: 'AVG Время',
        type: 'time',
        sort: true,
      },
      {
        value: 'qualified_median_time',
        label: 'Median Время',
        type: 'time',
        sort: true,
      },
    ],
  },
];

export const fieldsOfGroups = [
  {
    value: 'manager',
    label: 'Менеджер',
    type: 'link',
    // isEditLink: '/advertisers/offers/updateOffer',
    // isEdit: false,
    // edit: '/advertisers/offers/',
  },
  {
    value: 'deposit',
    label: 'Депозит',
    type: 'link',
    // rout: '/advertisers/offers/',
    // isEditLink: '/advertisers/offers/updateOffer',
    // isEdit: false,
    // edit: '/advertisers/offers/',
  },
  {
    value: 'offer',
    label: 'Оффер',
    type: 'link',
    rout: '/advertisers/offers/',
    isEditLink: '/advertisers/offers/updateOffer',
    isEdit: false,
    edit: '/advertisers/offers/',
  },
  {value: 'day', label: 'День', type: 'link'},
  {value: 'month', label: 'Месяц', type: 'link'},
  {value: 'year', label: 'Год', type: 'link'},
  {
    value: 'advertiser',
    label: 'Рекламодатель',
    type: 'link',
    rout: '/advertisers/list/',
    isEdit: false,
    isEditLink: '/advertisers/update',
    edit: '/advertisers/list/',
  },
  {value: 'brand', label: 'Бренд', type: 'link', isEdit: true, edit: '/advertisers/brands/'},
  {value: 'country', label: 'Страна', type: 'link'},
  {value: 'pwa', label: 'Приложение', type: 'link', rout: '/app/', isTimeConfig: true},
  {value: 'app', label: 'Приложение', type: 'link', rout: '/app/', isTimeConfig: true},
  {
    value: 'traffic',
    label: 'Кампания',
    type: 'link',
    rout: '/tracker/facebook/companies/',
    isFilter: true,
    isTimeConfig: true,
  },
  {value: 'bayer', label: 'Байер', type: 'link', rout: '/tracker/facebook/bayers/'},
  {
    value: 'source',
    label: 'Поток',
    type: 'link',
    rout: '/tracker/facebook/source/',
    isTimeConfig: true,
  },
  {
    value: 'finance',
    label: 'Финансы',
    marker: '#34C77E',
    type: 'link',
    rout: '/tracker/facebook/source/',
  },
  {value: 'pixel', label: 'Пиксели', type: 'link', rout: '/tracker/facebook/pixels/'},
  {value: 'landing', label: 'Лендинг', type: 'link'},
  {value: 'traffics_id', label: 'Кампания', type: 'link', rout: '/tracker/facebook/companies/'},
  {value: 'campaign', label: 'FB Campaigns', type: 'link'},
  {value: 'adset', label: 'FB Adsets', type: 'link'},
  {value: 'ad', label: 'FB Ads', type: 'link'},
  {value: 'app_type', label: 'Платформа', type: 'link', isNotSorted: true},
  {value: 'inf_source', label: 'INF Потоки', type: 'link'},
  {value: 'fb_source', label: 'FB Потоки', type: 'link'},
  {value: 'inf_bayer', label: 'Байер', type: 'link', rout: '/tracker/influence/bayers/'},
  {value: 'fb_bayer', label: 'Байер', type: 'link', rout: '/tracker/facebook/bayers/'},
  {value: 'inf_traffic', label: 'Блогер', type: 'link', rout: '/tracker/influence/bloggers/'},
  {
    value: 'fb_traffic',
    label: 'Кампания',
    type: 'link',
    rout: '/tracker/facebook/companies/',
    isTimeConfig: true,
  },
  {value: 'app_service', label: 'Сервис', type: 'link'},
  {value: 'traffic_type', label: 'Тип Трафика', type: 'link'},
  {value: 'traffic_source', label: 'Источник', type: 'link'},
  {value: 'bot', label: 'Бот', type: 'link'},
  {value: 'channel', label: 'Канал', type: 'link'},
  {value: 'tg_account', label: 'Телеграм Аккаунт', type: 'link'},
  {value: 'channel_group', label: 'Группа Каналов', type: 'link'},
];
